module.exports = __webpack_public_path__ + "officialStatic/img/new16.3f3b1b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new16.jpg
// module id = 74Rw
// module chunks = 0